import { TRequestData } from "src/shared/components/Hardware/types";

type RawRequestForDisplay = {
  id: number;
  user?: {
    name: string;
    email: string;
  };
  requested_at?: string | null;
  accepted_at?: string | null;
  ready_at?: string | null;
  picked_up_at?: string | null;
  returned_at?: string | null;
  denied_at?: string | null;
  cancelled_at?: string | null;
};

/** Build per-request display metadata keyed by request id. */
export const buildRequestDataById = (
  requestIds: Array<number | undefined>,
  rawRequests: RawRequestForDisplay[] | undefined
): Record<number, TRequestData> => {
  if (!rawRequests?.length) return {};

  const byId = new Map(rawRequests.map((request) => [request.id, request]));
  const requestDataById: Record<number, TRequestData> = {};

  for (const requestId of requestIds) {
    if (!requestId || requestDataById[requestId]) continue;
    const rawRequest = byId.get(requestId);
    if (!rawRequest) continue;

    requestDataById[requestId] = {
      id: rawRequest.id,
      user: rawRequest.user,
      requested_at: rawRequest.requested_at ?? undefined,
      accepted_at: rawRequest.accepted_at ?? undefined,
      ready_at: rawRequest.ready_at ?? undefined,
      picked_up_at: rawRequest.picked_up_at ?? undefined,
      returned_at: rawRequest.returned_at ?? undefined,
      denied_at: rawRequest.denied_at ?? undefined,
      cancelled_at: rawRequest.cancelled_at ?? undefined,
    };
  }

  return requestDataById;
};
